var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareBtnIos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f4f3",
    d: "M4.411 0h16.178A4.411 4.411 0 0 1 25 4.411v16.178A4.411 4.411 0 0 1 20.589 25H4.411A4.411 4.411 0 0 1 0 20.589V4.411A4.411 4.411 0 0 1 4.411 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.719 8.824h-0.945c-0.501 0 -0.983 0.206 -1.339 0.574a2.008 2.008 0 0 0 -0.552 1.386v7.844c0 0.519 0.199 1.017 0.555 1.386 0.352 0.367 0.835 0.574 1.336 0.574h9.453c0.501 0 0.983 -0.206 1.339 -0.574 0.352 -0.367 0.552 -0.867 0.552 -1.386V10.784c0 -0.519 -0.2 -1.017 -0.555 -1.385a1.857 1.857 0 0 0 -1.336 -0.575h-0.945M12.5 13.725V2.941m0 0L9.664 5.883M12.5 2.941l2.836 2.941",
    stroke: "#1379EE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.47
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBtnIos);
export default __webpack_public_path__ + "static/media/shareBtnIos.74b09b962efdc9326f6ef9001a06cd6c.svg";
export { ForwardRef as ReactComponent };